import React from 'react'
import { useState, ChangeEvent } from 'react'
import { Dropdown, Button, MenuProps } from 'antd'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import styles from './style.module.scss'
import checkIcon from 'assets/images/menu-check.svg'
import chevronDown24SVG from 'assets/images/chevron-down-24.svg'

type MeetingStatus = 'ACCEPTED' | 'DECLINED' | 'TENTATIVE'

interface EditResponseCommentProps {
  status?: MeetingStatus
  onSubmit: (comment: string, status: MeetingStatus) => void
  onCancel?: () => void
}

const EditResponseComment = ({
  status = 'ACCEPTED',
  onSubmit,
  onCancel,
}: EditResponseCommentProps) => {
  const [comment, setComment] = useState('')
  const [selectedStatus, setSelectedStatus] = useState<MeetingStatus>(status)
  const { t } = useTranslation()

  const handleSubmit = () => {
    onSubmit(comment, selectedStatus)
  }

  const items: MenuProps['items'] = [
    {
      key: 'ACCEPTED',
      label: (
        <div className={styles.menuItem}>
          <span>{t('meeting.status.accepted')}</span>
          {selectedStatus === 'ACCEPTED' && (
            <img src={checkIcon} alt="Selected" className={styles.checkIcon} />
          )}
        </div>
      ),
      onClick: () => setSelectedStatus('ACCEPTED'),
    },
    {
      key: 'DECLINED',
      label: (
        <div className={styles.menuItem}>
          <span>{t('meeting.status.declined')}</span>
          {selectedStatus === 'DECLINED' && (
            <img src={checkIcon} alt="Selected" className={styles.checkIcon} />
          )}
        </div>
      ),
      onClick: () => setSelectedStatus('DECLINED'),
    },
    {
      key: 'TENTATIVE',
      label: (
        <div className={styles.menuItem}>
          <span>{t('meeting.status.tentative')}</span>
          {selectedStatus === 'TENTATIVE' && (
            <img src={checkIcon} alt="Selected" className={styles.checkIcon} />
          )}
        </div>
      ),
      onClick: () => setSelectedStatus('TENTATIVE'),
    },
  ]

  const getStatusLabel = (): string => {
    switch (selectedStatus) {
      case 'ACCEPTED':
        return t('meeting.status.accepted')
      case 'DECLINED':
        return t('meeting.status.declined')
      case 'TENTATIVE':
        return t('meeting.status.tentative')
      default:
        return t('meeting.status.accepted')
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>{t('meeting.resComment.edit')}</h2>
      </div>
      <div className={styles.content}>
        <textarea
          className={styles.commentInput}
          placeholder={t('meeting.resComment.placeholder')}
          value={comment}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value)}
        />
      </div>
      <div className={styles.footer}>
        <Dropdown
          menu={{ items }}
          trigger={['click']}
          placement="top"
          overlayClassName={classNames('contextMenu')}
        >
          <button className={styles.statusButton}>
            {getStatusLabel()}
            <img src={chevronDown24SVG} alt="chevron-down" style={{ marginLeft: '8px' }} />
          </button>
        </Dropdown>
        <div className={styles.actions}>
          {onCancel && (
            <Button
              className={classNames('h38', 'w100')}
              style={{ minWidth: '100px' }}
              onClick={onCancel}
            >
              {t('common.button.cancel')}
            </Button>
          )}
          <Button className={classNames('type1', 'h38', 'w100')} onClick={handleSubmit}>
            {t('editor.tooltip.send')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EditResponseComment
